export default "__VITE_ASSET__de5b1065__"